import styles from "./OnboardingStyles.module.css"
import { useNavigate } from 'react-router-dom';
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import SecondaryButton from "../Button/SecondaryButton/SecondaryButton";
import CheckBox from "../CheckBox/CheckBox";
import { StepFormProps } from "../../types/onboarding.types";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useDontShowOnboarding } from "../../hooks/useDontShowOnboarding";
import { useTranslation } from "react-i18next";
/**
* Onboarding step.
*
* @param props StepFormProps
* @param {(step: number) => void} props.setStep - Step change handler
* @param {number} props.currentStep - Current step
* @param {OnboardingFormData} props.formData - Onboarding data
* @param {React.Dispatch<React.SetStateAction<OnboardingFormData>>} props.setFormData - Onboarding data change handler
* @param {() => void} props.clearData - Clear data handler
* @returns TSX.Element
*/
const Step1Form = ({ currentStep, setStep }:StepFormProps) => {
    const { t } = useTranslation(); // Translation
    const windowSize = useWindowSize(); // Window size
    const navigate = useNavigate(); // Navigate
    // Handle not showing onboarding again upon filling out order settings
    const {dontShow, setDontShow} = useDontShowOnboarding();
    
    return(
        <>
        <div className={styles.OnboardingContent}>
            <div className={styles.SecondaryContainer1}>
                <div className={styles.SecondaryTitle}>
                    <p>{t("onboarding.steps.1.title")}</p>
                </div>
                {windowSize > 900 ? (
                    <>
                    <div className={styles.MobileButtonGroup}>
                        <div className={styles.SecondaryActionButtons}>
                            <SecondaryButton onClick={() => navigate("/home")} text={t("onboarding.steps.1.buttons.no_help")} className={styles.WideSecondaryButton} showChevron={false} colorVariant="primary" />
                            <PrimaryButton onClick={()=>setStep(currentStep+1)} text={t("onboarding.steps.1.buttons.help")} className={styles.WideSecondaryButton}/>
                        </div>
                        <div className={styles.DontShow} onClick={()=>setDontShow(!dontShow)}>
                                <CheckBox text={t("onboarding.steps.1.dont_show")} onCheck={() => setDontShow(!dontShow)} checked={dontShow} />
                        </div>
                        </div>
                    </>
                ):(
                    <>
                    <div className={styles.MobileButtonGroup}>
                        <div className={styles.DontShow} onClick={()=>setDontShow(!dontShow)}>
                                <CheckBox text={t("onboarding.steps.1.dont_show")} onCheck={() => setDontShow(!dontShow)} checked={dontShow} />
                        </div>
                        <div className={styles.SecondaryActionButtons}>
                            <SecondaryButton onClick={() => navigate("/home")} text={t("onboarding.steps.1.buttons.no_help")} className={styles.WideSecondaryButton} showChevron={false} colorVariant="primary" />
                            <PrimaryButton onClick={()=>setStep(currentStep+1)} text={t("onboarding.steps.1.buttons.help_short")} className={styles.WideSecondaryButton}/>
                        </div>
                    </div>
                    </>
                )}
            </div>
        </div>
        </>
    )
};

export default Step1Form;